var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.621,
    height: 27.276,
    viewBox: "0 0 27.621 27.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16919",
    "data-name": "Group 16919",
    transform: "translate(-36.168 -10.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16344",
    "data-name": "Group 16344",
    transform: "translate(12.168 -2.699)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2228",
    "data-name": "Rectangle 2228",
    width: 26.182,
    height: 26.182,
    rx: 5,
    transform: "translate(24 14.217)",
    fill: "#427fef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16343",
    "data-name": "Group 16343",
    transform: "translate(24.878 13.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22366",
    "data-name": "Path 22366",
    d: "M51.2,45.224a2.1,2.1,0,0,1-1.895-1.189L38.45,22.979a2.119,2.119,0,1,1,3.807-1.86L53.115,42.192A2.1,2.1,0,0,1,52.151,45,2,2,0,0,1,51.2,45.224Z",
    transform: "translate(-38.234 -19.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22367",
    "data-name": "Path 22367",
    d: "M48.034,32.144A1.945,1.945,0,0,1,46.29,29.3l6.4-12.318a1.968,1.968,0,1,1,3.487,1.792l-6.4,12.318a1.936,1.936,0,0,1-1.744,1.056Z",
    transform: "translate(-29.735 -15.756)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.f361d091581f1527585ea0715242636c.svg";
export { ForwardRef as ReactComponent };